import { CapacityCalculationParams } from "./type";

export function isGroupFullOfGuests({
  nodeRequirePlayerCounts,
  nodeStandardCapacity,
  isGolfCourse,
  playersLength,
  groupSize = 1,
  bookingType,
}: CapacityCalculationParams): boolean {
  if (bookingType === "RequestBooking") {
    return nodeStandardCapacity === playersLength;
  } else if (!nodeRequirePlayerCounts || isGolfCourse) {
    return (nodeStandardCapacity || 0) + 1 === playersLength;
  }
  return playersLength === (groupSize || 1) + 1;
}
